import React from "react";
import { Box, Icon, InputBase, Paper, InputBaseProps } from "@mui/material";

export const InputSearch = React.forwardRef<HTMLInputElement, InputBaseProps>(
  (props, ref) => {
    return (
      <Box
        gap={1}
        display="flex"
        paddingLeft={2}
        component={Paper}
        alignItems="center"
      >
        <Icon sx={{ opacity: 0.5 }}>search</Icon>
        <InputBase
          ref={ref}
          fullWidth
          {...props}
          sx={{ p: 0.75, ...props.sx }}
        />
      </Box>
    );
  }
);
